module.exports = __webpack_public_path__ + "img/firmware_d.554f190b.svg";